import React from 'react';
import { FaFacebookF, FaXTwitter, FaInstagram, FaTiktok, FaYoutube, FaEnvelope, FaGlobe } from 'react-icons/fa6';
import { FaTelegramPlane, FaSnapchatGhost, FaPhoneAlt } from 'react-icons/fa';
import logo from './logo.svg';

const Footer = () => {
  return (
    <footer dir="ltr" className="bg-gray-100 py-1 font-exo text-sm">
      <div className="container mx-auto flex justify-between items-center">
        {/* Left side: Social media icons */}
        <div className="flex flex-col items-center space-y-1 text-footer-green">
          <div className="flex space-x-1 text-footer-green">
          <div className="flex items-center justify-center lg:w-6 lg:h-6 w-4 h-4 border-2 border-footer-green rounded-full text-footer-green ">
            <FaXTwitter />
            </div>
            <div className="flex items-center justify-center lg:w-6 lg:h-6 w-4 h-4 border-2 border-footer-green rounded-full text-footer-green">
            <FaFacebookF />
            </div>
            <div className="flex items-center justify-center lg:w-6 lg:h-6 w-4 h-4 border-2 border-footer-green rounded-full text-footer-green">
            <FaInstagram />
            </div>
            <div className="flex items-center justify-center lg:w-6 lg:h-6 w-4 h-4 border-2 border-footer-green rounded-full text-footer-green">
            <FaTiktok />
            </div>
            <div className="flex items-center justify-center lg:w-6 lg:h-6 w-4 h-4 border-2 border-footer-green rounded-full text-footer-green">
            <FaYoutube />
            </div>
            <div className="flex items-center justify-center lg:w-6 lg:h-6 w-4 h-4 border-2 border-footer-green rounded-full text-footer-green">
            <FaTelegramPlane />
            </div>
          </div>
          <p className="font-light text-xs lg:text-sm">MOISaudiArabia</p>
          <div className="flex  items-center justify-center text-footer-green lg:w-6 lg:h-6 w-4 h-4 border-2 border-footer-green rounded-full">
            <FaSnapchatGhost />
          </div>
          <p className="font-light text-xs lg:text-sm">Moi.saudiarabia</p>
        </div>

        {/* Center: Logo */}
        <div className="text-footer-green">
          <img src={logo} alt="Logo" className="h-28" />
        </div>

        {/* Right side: Contact info */}
        <div className="text-xs lg:text-sm flex flex-col space-y-1 text-gray-500 text-right">
          <div className="flex items-center flex-row-reverse space-x-reverse lg:space-x-2 space-x-1 ">
            <FaPhoneAlt className="text-footer-green" />
            <span>8004399999</span>
          </div>
          <div className="text-[8px] lg:text-sm flex items-center flex-row-reverse space-x-reverse lg:space-x-2 space-x-1 ">
            <FaEnvelope className="text-footer-green" />
            <span>8004399999@hq.moi.gov.sa</span>
          </div>
          <div className="text-xs lg:text-sm flex items-center flex-row-reverse space-x-reverse lg:space-x-2 space-x-1 ">
            <FaGlobe className="text-footer-green" />
            <span>www.moi.gov.sa</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
